import React from 'react'
import { Layout } from 'antd';
const { Footer } = Layout;
export default class FooterCompoents extends React.Component {
    render() {

        return (
            <Footer style={{ textAlign: 'center' }}>
                明道普霖斯頓雙語小學 ADD：台中市北屯區河北路三段16號 TEL：(04)22425588 FAX：(04)22428188 
            </Footer>
        )
    }
}



// WEBPACK FOOTER //
// ./src/dashboards_redux/components/DefaultDashboardTemplate/FooterCompoents.jsx